<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title step-name">Сведения о заявителе</div>

        <Subject :statement="statement" :subject="statement.subjects.applicant" />
      </v-col>
    </v-row>

    <v-row v-if="statement.correctTranslationStep2">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Прошу нотариуса совершить перевод и засвидетельствовать его верность
          удаленно
        </div>

        <Step2 :data="statement.correctTranslationStep2" />
      </v-col>
    </v-row>

    <v-row v-if="statement.correctTranslationStep3">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Реквизиты счета для возврата заявителю суммы платежа за совершение
          нотариального действия в случае отказа в совершении нотариального
          действия
        </div>

        <StepRequisites
          :data="statement.correctTranslationStep3"
          :statement-type="StatementType.CORRECT_TRANSLATION"
        />
      </v-col>
    </v-row>

    <v-row v-if="statement.locationStep">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Выбор места совершения нотариального действия
        </div>

        <StepSign :data="statement.locationStep" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Subject from '@/components/elements/statement/FullStatementView/elements/Subject';
import Step2 from '@/components/elements/statement/FullStatementView/steps/CorrectTranslation/Step2';
import StepRequisites from '@/components/elements/statement/FullStatementView/steps/common/StepRequisites';
import StepSign from '@/components/elements/statement/FullStatementView/steps/common/StepSign';
import { StatementType } from '@/types/services';

export default {
  name: 'CorrectTranslation',
  components: {
    Subject,
    Step2,
    StepRequisites,
    StepSign,
  },
  props: {
    statement: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    StatementType,
  }),
};
</script>
